/**
 * Localization messages for RoleCardHeaderCompact component
 */
import sharedMessages from '../../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../../utils/localization';

const componentMessages = {
  // add component-specific messages here
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RoleCardHeaderCompactMessage = keyof typeof invertedMessages;

export default invertedMessages;
